<template>
  <div class="m-content-card515-wrapper">
    <m-content-wrapper :content-type="contentType" :content-category="contentCategory">
      <template v-slot="{contents}">
        <div class="m-content-card515-item ">
          <m-a v-for="content in contents" :key="content.id" class="text-decoration-none"
               :href="findLinkOnContent(content.abstraction)">
            <m-content-card515 class="card515 text-white py-5 " :content="content"/>
          </m-a>

        </div>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import {ContentArchiveProps} from './ContentArchiveProps'
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mContentCard515 from "../Card/ContentCard515";
import mA from '../../Tags/A'

export default {
  name: "ContentArchive1",
  components: {mContentWrapper, mContentCard515, mA},
  props: {
    ...ContentArchiveProps
  }
}
</script>

<style scoped>

</style>